<template>
  <div class="header-button-container" @click="click">
    <FontAwesomeIcon
      :icon="icon"
      class="icon"
      :style="buttonStyle"
    >
    </FontAwesomeIcon>
    <span class="title" :style="titleStyle">{{label}}</span>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
/* todo this component contains obsolete icon design. Consider to replace it on BaseMaterialDesignIcon.vue */
fontAwesomeIconLibrary.add(
  require('@fortawesome/free-solid-svg-icons/faFile').definition,
  require('@fortawesome/free-solid-svg-icons/faLink').definition,
  require('@fortawesome/free-solid-svg-icons/faFilePdf').definition,
  require('@fortawesome/free-solid-svg-icons/faShareAltSquare').definition,
  require('@fortawesome/free-solid-svg-icons/faSignOutAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowRight').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowDown').definition,
  require('@fortawesome/free-solid-svg-icons/faClock').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleRight').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleDown').definition,
  require('@fortawesome/free-solid-svg-icons/faCalendarDay').definition,
  require('@fortawesome/free-solid-svg-icons/faPlusCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faDownload').definition,
  require('@fortawesome/free-solid-svg-icons/faCamera').definition,
  require('@fortawesome/free-solid-svg-icons/faHome').definition,
  require('@fortawesome/free-solid-svg-icons/faCalendarAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faFlag').definition,
  require('@fortawesome/free-solid-svg-icons/faBook').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition
)
/**
 * Button with font awesome icon
 */
export default {
  name: 'BaseImageTextButton',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    FontAwesomeIcon

  },
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    buttonStyle: {
      type: Object
    },
    titleStyle: {
      type: Object
    }
  },
  methods: {
    click: function () {
      this.$emit('image-button-click')
    }
  }
}
</script>
<style scoped lang="scss">
  .icon {
    color: inherit;
  }

  .title {
    font-size: 14px;
    font-weight: 500;
    color: $rfx-dark-march;
    margin-left: 12px;
    white-space: nowrap;
  }

  .header-button-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: $rfx-dark-march;
    &:hover {
      color: $rfx-bright-turquoise;
    }
  }
</style>
